export const RUBLE_SIGN = '₽';
export const SQ_METER_SIGN = 'м²';
export const DOT_SIGN = '•';

/* ------------------------------------------------------------------------------------ */

export const SITE_URL = 'reit.com';
export const APARTMENT_RESERVE_TIME = 24;

export const AUTH_CODE_RESEND_TIMEOUT = 60;
export const ITEMS_PER_PAGE = 6;
export const DEFAULT_ROOM_COUNT_ARRAY = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

export const COMPLAINT_REASONS_MAP = [
  ['Продано', 'Sold'],
  ['Неверная цена', 'WrongPrice'],
  ['Неверные фотографии', 'IncorrectPhotos'],
  ['Не дозвониться', 'Unreachable'],
  ['Имеет статус нежилой недвижимости', 'IsNonResidential'],
] as const;

/* ------------------------------------------------------------------------------------ */

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const IS_DEV = import.meta.env.DEV;
export const SENTRY_TRACING = import.meta.env.VITE_SENTRY_TRACING;
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
export const SENTRY_ENV = import.meta.env.VITE_SENTRY_ENV;
export const SENTRY_RELEASE = import.meta.env.VITE_SENTRY_RELEASE;
export const API_WIZARD_SELL = import.meta.env.VITE_API_LANDING_URL + '/sell';
export const API_WIZARD_BUY = import.meta.env.VITE_API_LANDING_URL + '/buy';
export const API_WIZARD_DEAL_SERVICE = import.meta.env.VITE_API_LANDING_URL + '/deal-service';

export const TILDA_PATHS = {
  reitInvest: {
    tradeIn: "https://reit-invest.ru/tradein"
  },
  itReit:{
    sell: 'https://itreit.ru/sell',
    buy: 'https://itreit.ru/buy',
    dealService: 'https://itreit.ru/deal-service',
  }
};

/* ------------------------------------------------------------------------------------ */
